export const engagementCampaignsForUco = "/engagement/campaigns_for_uco";
